<template>
  <div>
    <main-loading v-if="isSaving"></main-loading>
    <div v-if="isLoading" class="container">
      <div class="row">
        <div class="col-12 text-center">
          <fp-loading></fp-loading>
        </div>
      </div>
    </div>
    <div v-else class="container" style="margin-bottom: 100px;" ref="container">
      <nav aria-label="breadcrumb" v-if="this.apartment.objectId && this.draftApartmentInfo && this.draftApartmentInfo.get('acceptedIndividual')">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link :to="`/main/${this.apartmentId}`">หน้าหลัก</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">จัดการข้อมูลโฆษณา</li>
        </ol>
      </nav>
      <div v-if="state === 'accept_policy'">
        <div class="row">
          <div class="col-12">
            <div class="text-center">
              <h3 class="text-primary">กรุณาอ่านข้อกำหนดและเงื่อนไขการใช้บริการ (Term of Service)</h3>
            </div>
          </div>
          <div class="col-12">
            <div class="text-center">
              <iframe src="https://www.rentini.in.th/about/terms?header=hide&footer=hide" title="Rentini Term Of Service" style="width: 100%;height:350px"></iframe>
            </div>
            <p class="text-center">
              เมื่อคลิกปุ่ม ยินยอม แสดงว่าคุณยินยอมตาม <span class="text-primary" target="_blank">ข้อกำหนดและเงื่อนไขการใช้บริการ (Term of Service)</span> ของเราแล้ว
            </p>
          </div>
          <div class="col-6">
            <button class="btn btn-block shadow" :disabled="isSaving" @click="$bvModal.show('not-accept-modal')">ไม่ยินยอม</button>
            <modal-text-input :id="'not-accept-modal'" title="กรุณากรอกเหตุผลที่ไม่ยินยอม" content="กรุณากรอกเหตุผลที่ไม่ยินยอม" :onConfirm="notAcceptPolicy"></modal-text-input>
          </div>
          <div class="col-6">
            <button class="btn btn-primary btn-block shadow" :disabled="isSaving" @click="acceptPolicy">ยินยอม</button>
          </div>
        </div>
      </div>
      <div v-else-if="state === 'choose_package'">
        <div class="row">
          <div class="col-12">
            <h3 class="text-center">กรุณาเลือก Package การใช้บริการ</h3>
          </div>
        </div>
        <package-detail :onChoosePackage="choosePackage"></package-detail>
        <!-- <coins-detail></coins-detail> -->
        <modal-notice
          :id="'modal-package-notice'"
          title="ทีมงานจะติดต่อกลับหาคุณภายใน 1-3 วันทำการ"
          content="คุณสามารถลงข้อมูลหอพักเพื่อขึ้นโปรโมทในระบบ"
          confirm-text="เริ่มการลงข้อมูล"
          :onConfirm="startDraftApartment"
        >
        </modal-notice>
      </div>
      <div v-else>
        <div class="alert alert-warning" v-if="
        this.apartment.objectId 
        && stepStatus[6] === true
        && this.draftApartmentInfo && !this.draftApartmentInfo.get('acceptedIndividual')
        ">
          <i class="fa fa-clock"></i> ข้อมูลของคุณกำลังอยู่ในขั้นตอนการตรวจสอบ หากได้รับการยืนยันเรียบร้อยแล้วข้อมูลจะถูกประกาศบนหน้าเว็บไซต์โดยอัตโนมัติ
        </div>
        <apartment-form 
          v-model="apartment" 
          :disabled="isSaving" 
          :rooms="rooms"
          :facilities="facilities"
          :room-features="roomFeatures"
          :mode="mode"
          :onModeChange="(index) => { mode = index; }"
          :stepStatus="stepStatus"
          :missingForm="missingForm"
        />
        <button type="button" class="btn btn-success btn-block shadow mr-2 mt-2"
        v-if="mode < 6" @click.prevent="save(false)" :disabled="isSaving">
          <i class="fas fa-sync-alt fa-spin" v-if="isSaving"></i>
          <i class="fas fa-save" v-else></i> บันทึกข้อมูล
        </button>
        <div class="modal fade" id="save-status-modal">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">การบันทึกข้อมูลหอพักสำเร็จ</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body text-center">
                <div class="text-center">
                  การบันทึกข้อมูลหอพักสำเร็จ
                </div>
                <div class="mt-2" v-if="this.apartment.objectId && stepStatus[6] === true">
                  <a class="btn btn-success" :href="`${ this.rentiniUrl }/p/${this.apartment.objectId}`" target="_blank">
                    คลิกที่นี่เพื่อดูประกาศหอพักของคุณ
                  </a>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-light" data-dismiss="modal" v-if="mode < 5" :disabled="isSaving">แก้ไขต่อ</button>
                <button class="btn btn-primary" @click="nextPage" v-if="mode < 5" :disabled="isSaving">หน้าถัดไป</button>
                <button class="btn btn-primary" data-dismiss="modal" v-else :disabled="isSaving"><i class="fas fa-check"></i> OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {
      rentiniUrl: process.env.VUE_APP_RENTINI_BASE_URL,
      state: "accept_policy",
      draftApartmentInfo: null,
      apartment: {
        id: null,
        apartmentCode: null,
        name: null,
        name_en: null,
        ownerName: null,
        email: null,
        tel: null,
        sexType: 'shared',
        waterCost: null,
        elecCost: null,
        highlightDetail: null,
        nearbyDetail: null,
        internetCost: null,
        centralCost: null,
        otherCost: null,
        hiddenWaterCost: false,
        hiddenElecCost: false,
        hideInternetCost: false,
        hideCentralCost: false,
        hideOtherCost: false,
        facilities: [],
        acceptedIndividual:false,
        acceptedPositive:false,
        acceptedNegative:false,
        acceptedQuarantine:false,
        acceptedMedicalStaff:false,
        servicesCost: null,
        roomTypes: [],
        contract: 0,
        position: {
          lat: 13.7244416,
          lng: 100.3528916,
        },
        images: [],
        apartmentRules: [""],
        note: null,
        nearBy: null,
        landmark: null,
        area: null,
        address: null,
        objectId: null
      },
      refApartment: null,
      isSaving: false,
      isLoading: true,
      errorMessage: '',
      rooms: [],
      facilities: [],
      roomFeatures: [],
      mode: 1,
      publishUrl: '',
      publishSuccessMessage: '',
      publishErrorMessage: '',
      isFromMobile: false,
      baseUrl: "",
      sessionToken: "",
      apartmentId: "",
      stepStatus: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
      },
      missingForm: {},
      apartmentParseObject: null
    }
  },
  methods: {
    getAcceptPolicy(user) {
      let query = new this.Parse.Query('ApartmentAdvertisePolicyAcceptance')
      query.equalTo('user', user)
      query.equalTo('isAccepted', true)
      return query.first();
    },
    async notAcceptPolicy(reason) {
      this.isSaving = true
      let user = this.Parse.User.current()
      let Apartment = this.Parse.Object.extend('Apartment')
      let apartment = new Apartment()
      apartment.id = this.apartmentId
      
      let ApartmentAdvertisePolicyAcceptance = this.Parse.Object.extend('ApartmentAdvertisePolicyAcceptance')
      let aapa = new ApartmentAdvertisePolicyAcceptance()
      aapa.set({
        apartment,
        user,
        isAccepted: false,
        notAcceptReason: reason || ""
      })

      let acl = new this.Parse.ACL()
      acl.setReadAccess(user, true);
      acl.setWriteAccess(user, true);
      aapa.setACL(acl);
      await aapa.save()
      this.isSaving = false
      this.$bvToast.toast('ทางทีมงานจะนำความคิดเห็นของท่านไปปรับปรุงเงื่อนไขการใช้บริการ', {
        title: `ขอบคุณสำหรับข้อมูล`,
        variant: 'success',
        solid: true
      })
    },
    async acceptPolicy() {
      this.isSaving = true
      let user = this.Parse.User.current()
      let Apartment = this.Parse.Object.extend('Apartment')
      let apartment = new Apartment()
      apartment.id = this.apartmentId
      
      let ApartmentAdvertisePolicyAcceptance = this.Parse.Object.extend('ApartmentAdvertisePolicyAcceptance')
      let aapa = new ApartmentAdvertisePolicyAcceptance()
      aapa.set({
        apartment,
        user,
        isAccepted: true
      })

      let acl = new this.Parse.ACL()
      acl.setReadAccess(user, true);
      acl.setWriteAccess(user, true);
      aapa.setACL(acl);
      await aapa.save()
      
      let packageName = this.apartmentParseObject.get("package").get("code") === "pro" ? "premium" : "pro";
      await this.choosePackage(packageName);
      this.isSaving = false
    },
    async choosePackage(packageName){
      this.isSaving = true
      try {
        let response = await this.axios({
          url: `${process.env.VUE_APP_RENTINI_PARTNER_PARSE_SERVER_URL}/functions/generateDraftApartment`,
          method: 'POST',
          data: {
            apartmentId: this.apartmentId
          },
          headers: {
            "X-Parse-Application-Id": process.env.VUE_APP_RENTINI_PARTNER_PARSE_APP_ID,
            "X-Parse-Session-Token": this.sessionToken,
            "Content-Type": "application/json"
          }
        })
        let draftApartment = this.Parse.Object.fromJSON(response.data.result)
        await this.axios({
          url: `${process.env.VUE_APP_RENTINI_PARTNER_PARSE_SERVER_URL}/functions/chooseRentiniPackage`,
          method: 'POST',
          data: {
            draftId: draftApartment.id,
            packageName: packageName,
            choosePackageAt: {
              "__type": "Date",
               "iso": new Date().toISOString()
            }
          },
          headers: {
            "X-Parse-Application-Id": process.env.VUE_APP_RENTINI_PARTNER_PARSE_APP_ID,
            "X-Parse-Session-Token": this.sessionToken,
            "Content-Type": "application/json"
          }
        })
        this.draftApartmentInfo = draftApartment;
        // if(packageName === 'pro' || packageName === 'premium') this.$bvModal.show('modal-package-notice');
        // else this.startDraftApartment();
        this.startDraftApartment();
      } catch (error) {
        this.$bvToast.toast(error, {
          title: `เกิดข้อผิดพลาด !`,
          variant: 'danger',
          solid: true
        })
      }
      this.isSaving = false;
    },
    async startDraftApartment(){
      this.state = "main"
    },
    async getHgnApartment(apartmentId){
      let query = new this.Parse.Query('Apartment')
      let apartment = await query.get(apartmentId)
      this.apartmentParseObject = apartment
      let roomQuery = new this.Parse.Query('Room')
      roomQuery.equalTo('apartment', apartment)
      roomQuery.include(['roomRate', 'standardRate', 'package'])
      roomQuery.limit(10000)
      let rooms = await roomQuery.find()

      let draftApartmentInfoQuery = new this.Parse.Query('DraftApartmentInfo')
      draftApartmentInfoQuery.equalTo('apartment', apartment)
      let draftApartmentInfo = await draftApartmentInfoQuery.first()
      let roomTypes
      if (draftApartmentInfo) {
          let query = new this.Parse.Query('DraftRoomType')   
          query.equalTo('apartmentInfo', draftApartmentInfo)
          query.ascending('order')
          roomTypes = await query.find()
      }
      return {
          success: true,
          apartment,
          draftApartmentInfo,
          roomTypes,
          rooms
      }
    },
    nextPage() {
      // eslint-disable-next-line 
      $('#save-status-modal').modal('hide')
      if(this.mode < 6) {
        this.mode ++;
        document.documentElement.scrollTop = 0;
      }
    },
    async save() {
      this.missingForm = {}
      let checkForm = this.isDone(this.mode, this.apartment)
      if(!checkForm.isDone) {
        this.missingForm = checkForm.missingForm;
        this.$bvToast.toast('กรุณากรอกข้อมูลให้ครบถ้วน ในช่องที่มีเครื่องหมาย *', {
          title: `กรุณากรอกข้อมูลให้ครบถ้วน`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      this.isSaving = true
      //copy apartment first
      let apartment = _.cloneDeep(this.apartment)
      apartment.facilities = apartment.facilities.map( f => {
        return f.id
      })

      if(apartment.roomTypes && apartment.roomTypes.length) apartment.roomTypes = apartment.roomTypes.slice()
      apartment.roomTypes.map((rt, index) => {
        //set order
        rt.order = index;

        if(rt.roomsSelected) {
          rt.roomsSelected = rt.roomsSelected.map(rs => {
            return rs.id
          })
        }else{
          rt.roomsSelected = []
        }

        if(rt.roomFeature && rt.roomFeature.length) rt.roomFeature = rt.roomFeature.slice()
        if(rt.roomFeature && rt.roomFeature.length) {
          rt.roomFeature = rt.roomFeature.map(rf => {
            return rf.id
          })
        }else{
          rt.roomFeature = []
        }
      })
      try {
        let response = await this.axios({
          url: `${process.env.VUE_APP_RENTINI_PARTNER_PARSE_SERVER_URL}/functions/saveApartment`,
          method: 'POST',
          data: {
            apartment
          },
          headers: {
            "X-Parse-Application-Id": process.env.VUE_APP_RENTINI_PARTNER_PARSE_APP_ID,
            "X-Parse-Session-Token": this.sessionToken,
            "Content-Type": "application/json"
          }
        })
        let result = response.data.result || {}
        if(!result.error) {
          this.apartment.objectId = result.apartment.objectId
          if(result.roomTypes && result.roomTypes.length) {
            for(let index in result.roomTypes) {
              this.apartment.roomTypes[index].objectId = result.roomTypes[index].objectId
            }
          }
          // eslint-disable-next-line 
          $('#save-status-modal').modal({backdrop: 'static', keyboard: false})
        }else{
          alert(result.error)
        }
        this.isSaving = false
        this.updateStep()
      } catch (error) {
        this.isSaving = false
        alert(error)
        return {error}
      }
    },
    async publish(preparedApartment) {
      this.isSaving = true
      let apartment = _.cloneDeep(preparedApartment)
      apartment.roomTypes.map(rt => {
        if(rt.roomsSelected) {
          rt.roomsSelectedId = rt.roomsSelected.map(rs => rs.id)
          delete rt.roomsSelected
        }
      })
      try {
        let res = await this.$hawks.Cloud.run('publishApartment', {
          apartment
        })
        await this.Parse.Cloud.run('setPublishedApartmentStatus', {
          apartmentId: this.apartmentId
        })
        this.publishUrl = res.publishUrl
        this.publishSuccessMessage = 'เผยแพร่สำเร็จ'
      } catch (error) {
        this.publishErrorMessage = error.message
      }
      this.isSaving = false
    },
    getServicesCost(rooms) {
      let servicesSummary = {}

      rooms.map((room) => {
        if(room.get('servicesRate')) {
          let services = room.get('servicesRate')
  
          services.forEach((service) => {
            if(!service.type) service.type = 0
            if(!servicesSummary[service.apartmentService]) {
              servicesSummary[service.apartmentService] = {
                name: service.name,
                types: {}
              }
            }
            if(!servicesSummary[service.apartmentService]['types'][service.type]) {
              servicesSummary[service.apartmentService]['types'][service.type] = {
                min: 0,
                max: 0
              }
            }
  
            switch (service.type) {
              case 0:
                //min
                if(servicesSummary[service.apartmentService]['types'][service.type].min) {
                  if(servicesSummary[service.apartmentService]['types'][service.type].min > service.cost_month) {
                    servicesSummary[service.apartmentService]['types'][service.type].min = service.cost_month
                  }
                } else {
                  servicesSummary[service.apartmentService]['types'][service.type].min = service.cost_month
                }         
                //max
                if(servicesSummary[service.apartmentService]['types'][service.type].max) {
                  if(servicesSummary[service.apartmentService]['types'][service.type].max < service.cost_month) {
                    servicesSummary[service.apartmentService]['types'][service.type].max = service.cost_month
                  }
                } else {
                  servicesSummary[service.apartmentService]['types'][service.type].max = service.cost_month
                }         
                break;
              default:
                //min
                if(servicesSummary[service.apartmentService]['types'][service.type].min) {
                  if(servicesSummary[service.apartmentService]['types'][service.type].min > service.cost_per_unit) {
                    servicesSummary[service.apartmentService]['types'][service.type].min = service.cost_per_unit
                  }
                } else {
                  servicesSummary[service.apartmentService]['types'][service.type].min = service.cost_per_unit
                }
                //max         
                if(servicesSummary[service.apartmentService]['types'][service.type].max) {
                  if(servicesSummary[service.apartmentService]['types'][service.type].max < service.cost_per_unit) {
                    servicesSummary[service.apartmentService]['types'][service.type].max = service.cost_per_unit
                  }
                } else {
                  servicesSummary[service.apartmentService]['types'][service.type].max = service.cost_per_unit
                }         
                break;
            }
          })
        }

      })

      return servicesSummary
    },
    setApartmentInfo(apartmentInfo) {
      this.apartment.objectId = apartmentInfo.id
      if(apartmentInfo.get('name')) this.apartment.name = apartmentInfo.get('name')
      if(apartmentInfo.get('name_en')) this.apartment.name_en = apartmentInfo.get('name_en')
      if(apartmentInfo.get('apartmentCode')) this.apartment.apartmentCode = apartmentInfo.get('apartmentCode')
      if(apartmentInfo.get('ownerName')) this.apartment.ownerName = apartmentInfo.get('ownerName')
      if(apartmentInfo.get('tel')) this.apartment.tel = apartmentInfo.get('tel')
      if(apartmentInfo.get('address')) this.apartment.address = apartmentInfo.get('address')
      if(apartmentInfo.get('facilities')) this.apartment.facilities = apartmentInfo.get('facilities')
      if(apartmentInfo.get('email')) this.apartment.email = apartmentInfo.get('email')
      if(apartmentInfo.get('sexType')) this.apartment.sexType = apartmentInfo.get('sexType')
      if(apartmentInfo.get('hiddenWaterCost')) this.apartment.hiddenWaterCost = apartmentInfo.get('hiddenWaterCost')
      if(apartmentInfo.get('hiddenElecCost')) this.apartment.hiddenElecCost = apartmentInfo.get('hiddenElecCost')
      if(apartmentInfo.get('waterCost')) this.apartment.waterCost = apartmentInfo.get('waterCost')
      if(apartmentInfo.get('elecCost')) this.apartment.elecCost = apartmentInfo.get('elecCost')
      if(apartmentInfo.get('highlightDetail')) this.apartment.highlightDetail = apartmentInfo.get('highlightDetail')
      if(apartmentInfo.get('nearbyDetail')) this.apartment.nearbyDetail = apartmentInfo.get('nearbyDetail')
      if(apartmentInfo.get('apartmentRules'))this.apartment.apartmentRules = apartmentInfo.get('apartmentRules')
      if(apartmentInfo.get('images')) this.apartment.images = apartmentInfo.get('images')
      if(apartmentInfo.get('contract')) this.apartment.contract = apartmentInfo.get('contract')
      if(apartmentInfo.get('address')) this.apartment.address = apartmentInfo.get('address')
      if(apartmentInfo.get('provinceCode')) this.apartment.provinceCode = apartmentInfo.get('provinceCode')
      if(apartmentInfo.get('districtCode')) this.apartment.districtCode = apartmentInfo.get('districtCode')
      if(apartmentInfo.get('subDistrictCode')) this.apartment.subDistrictCode = apartmentInfo.get('subDistrictCode')
      if(apartmentInfo.get('servicesCost')) this.apartment.servicesCost = apartmentInfo.get('servicesCost')

      if(apartmentInfo.get('position')) {
        this.apartment.position = {
          lat: apartmentInfo.get('position').latitude,
          lng: apartmentInfo.get('position').longitude
        }
      }

      // if(apartmentInfo.get('acceptedCustomerTypes')) this.apartment.acceptedCustomerTypes = apartmentInfo.get('acceptedCustomerTypes')
      // if(apartmentInfo.get('acceptedIndividual')) this.apartment.acceptedIndividual = apartmentInfo.get('acceptedIndividual')
      // if(apartmentInfo.get('acceptedPositive')) this.apartment.acceptedPositive = apartmentInfo.get('acceptedPositive')
      // if(apartmentInfo.get('acceptedNegative')) this.apartment.acceptedNegative = apartmentInfo.get('acceptedNegative')
      // if(apartmentInfo.get('acceptedQuarantine')) this.apartment.acceptedQuarantine = apartmentInfo.get('acceptedQuarantine')
      // if(apartmentInfo.get('acceptedMedicalStaff')) this.apartment.acceptedMedicalStaff = apartmentInfo.get('acceptedMedicalStaff')
    },
    setRoomTypes(roomTypes) {
      this.apartment.roomTypes = roomTypes.map(roomType => {
        let roomFeature
        let roomsSelected
        if(roomType.get('roomFeature')) {
          roomFeature = roomType.get('roomFeature').map(rf => {
            return rf
          })
        }
        if(roomType.get('roomsSelected')) {
          roomsSelected = roomType.get('roomsSelected').map(rs => {
            return rs
          })
        }
        let preparedRoomType = {
          name: roomType.get('name'),
          cost: roomType.get('cost'),
          maxCost: roomType.get('maxCost'),
          bookingCost: roomType.get('bookingCost'),
          assuranceCost: roomType.get('assuranceCost'),
          isAdvancedCost: roomType.get('isAdvancedCost'),
          keyCost: roomType.get('keyCost'),
          keyCardCost: roomType.get('keyCardCost'),
          hideCost: roomType.get('hideCost'),
          availableRooms: roomType.get('availableRooms'),
          isRoomAvailable: roomType.get('isRoomAvailable'),
          maxRenter: roomType.get('maxRenter'),
          size: roomType.get('size'),
          images: roomType.get('images'),
          objectId: roomType.id,
          roomFeature,
          roomsSelected
        }
        this.rooms.map(room => {
          if(_.find(preparedRoomType.roomsSelected, r => { return room.id==r.id })) {
            room.roomType = preparedRoomType
          }
        })
        return preparedRoomType
      })
    },
    isDone(step, value) {
      let missingForm = {};
      let isDone = true
      switch (step) {
        case 1:
          if(!value.name) { isDone = false; missingForm['name'] = true; }
          if(!value.ownerName) { isDone = false; missingForm['ownerName'] = true; }
          if(!value.tel) { isDone = false; missingForm['tel'] = true; }
          if(!value.sexType) { isDone = false; missingForm['sexType'] = true; }
          if(!value.waterCost) { isDone = false; missingForm['waterCost'] = true; }
          if(!value.elecCost) { isDone = false; missingForm['elecCost'] = true; }
          break;
        case 2:
          if(!value.address) { isDone = false; missingForm['address'] = true; }
          if(!value.provinceCode) { isDone = false; missingForm['provinceCode'] = true; }
          if(!value.districtCode) { isDone = false; missingForm['districtCode'] = true; }
          if(!value.position) {
            isDone = false
            missingForm['position'] = true
          } else {
            if(value.position.lat === 13.7244416 && value.position.lng === 100.3528916) {
              isDone = false
              missingForm['position'] = true
            }
          }
          break;
        case 3:
          if(!value.roomTypes.length) {
            isDone = false
            missingForm['addRoomType'] = true
          } else {
            for (let index = 0; index < value.roomTypes.length; index++) {
              let roomType = value.roomTypes[index];
              if(!roomType.name) {
                isDone = false
                missingForm['roomTypeName_'+index] = true
                break
              }
            }
          }
          break;
        case 4:
          if(!value.images || (value.images && !value.images.length)) {
            isDone = false
            missingForm['mainImage'] = true
          }
          if(value.roomTypes) {
            for (let index = 0; index < value.roomTypes.length; index++) {
              let roomType = value.roomTypes[index];
              if(!roomType.images || (roomType.images && !roomType.images.length)) {
                isDone = false
                missingForm['roomTypeImage_'+index] = true
                break
              }
            }
          }
          break;
        case 5:
          if(!value.apartmentRules.length) { isDone = false }
          else {
            isDone = false
            for (let rule of value.apartmentRules) {
              if(rule) isDone = true
            }
          }
          if(!isDone) {
            missingForm["apartmentRules"] = true;
          }
          break;
      }
      return {
        isDone,
        missingForm
      }
    },
    updateStep() {
      let isFinished = true;
      for (let index = 1; index < 6; index++) {
        this.stepStatus[index] = this.isDone(index, this.apartment).isDone || false
        if(!this.stepStatus[index]) isFinished = false
      }
      if(isFinished) this.stepStatus[6] = true
    },
    getApartmentFacilities() {
      let query = new this.Parse.Query('ApartmentFacility')
      query.ascending('order')
      return query.find()
    },
    getRoomFeatures() {
      let query = new this.Parse.Query('ApartmentRoomFeature')
      query.ascending('order')
      return query.find()
    }
  },
  async mounted() {
    try {
      let user = this.Parse.User.current()
      let sessionToken = user.getSessionToken();
      let apartmentId = this.$route.params.apartmentId

      if(apartmentId && sessionToken) {
        this.apartmentId = apartmentId;
        this.sessionToken = sessionToken

        this.apartment.apartmentId = apartmentId
        this.refApartment = apartmentId
        this.facilities = await this.getApartmentFacilities()
        this.roomFeatures = await this.getRoomFeatures()

        let data = await this.getHgnApartment(apartmentId)
        if(data.draftApartmentInfo) {
          this.draftApartmentInfo = data.draftApartmentInfo
          this.setApartmentInfo(data.draftApartmentInfo)
          if(!this.draftApartmentInfo.get('package')) this.state = 'accept_policy'
          else this.state = 'main'
        } else {
          this.state = 'accept_policy'
        }

        this.rooms = data.rooms
        if(data.roomTypes) this.setRoomTypes(data.roomTypes)

        if(!this.apartment.name) this.apartment.name = data.apartment.get('name')
        if(!this.apartment.ownerName) this.apartment.ownerName = user.get('userProfile').get('firstName') + ' ' + user.get('userProfile').get('lastName')
        if(!this.apartment.tel) {
          if(!data.apartment.get('tel') || (data.apartment.get('tel') && !data.apartment.get('tel').length)) {
            this.apartment.tel = ''
          }
        }
        if(!this.apartment.email) this.apartment.email = data.apartment.get('email')
        if(!this.apartment.address) this.apartment.address = data.apartment.get('addressDetail') || ""
        if(!this.apartment.provinceCode) this.apartment.provinceCode = data.apartment.get('addressProvince')
        if(!this.apartment.districtCode) this.apartment.districtCode = data.apartment.get('addressDistrict')
        if(!this.apartment.subDistrictCode) this.apartment.subDistrictCode = data.apartment.get('addressSubDistrict')
        if(this.apartment.position.lat === 13.7244416  && this.apartment.position.lng === 100.3528916) {
          // If Position is default check geolocation from horganice 
          if(data.apartment.get('geolocation')) {
            this.apartment.position.lat = data.apartment.get('geolocation').latitude
            this.apartment.position.lng = data.apartment.get('geolocation').longitude
          }
        }

        //added service cost
        if(!this.apartment.servicesCost) {
          let servicesCost = this.getServicesCost(this.rooms)
          this.apartment.servicesCost = servicesCost
        }

        if(!this.apartment.apartmentCode) this.apartment.apartmentCode = data.apartment.id
        // Step Status
        this.updateStep()
        // Check Policy
        let isAcceptPolicy = await this.getAcceptPolicy(user)
        if(!isAcceptPolicy) {
          this.state = 'accept_policy'
        }

      }else{
        this.$router.push({ name: 'Error', params: { message: 'apartmentId and sessionToken not found.' } })
      }
      this.isLoading = false
    } catch (error) {
      this.$router.push({ name: 'Error', params: { message: 'error' } })
    }
  },
  computed: {
    previewUrl() {
        return `${this.baseUrl}/${this.apartment.apartmentCode}`
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
  margin-bottom: 150px;
}

.save-btn {
  position: fixed;
  bottom: 50px;
  width: 150px;
  margin-right: auto;
  margin-left: auto;
}
.overlay {
  opacity:0.8;
  background-color:rgba(0,0,0,0.8);
  position:fixed;
  width:100%;
  height:100%;
  top:0px;
  left:0px;
  z-index:1000;
}

.loading {
  color: white;
  position: fixed;
  top: 50%;
  left: 50%;
}

.img-fluid {
  max-height: 600px;
}
a {
  &:hover {
    text-decoration: none !important;
  }
}
</style>


